module.exports = {
  "id": "jump",
  "title": "jump",
  "color": "pink",
  "icon": "jump",
  "category": "keyboard",
  "searchTags": ["hop","leap","bounce","up","gravity"],
  "exposedVariables": [
    {
      "tooltip":"Adjust how high this piece can jump",
      "variableName": "Jump Strength",
      "spriteName": "$glitch_target",
      "value": 9,
      "input": {
        "type": "slider",
        "max": 25,
        "min": 0,
        "step": ".1",
        "id": "jump-strength-slider"
      }
    },
    {
      "tooltip":"Set what button on your keyboard makes this piece jump",
      "variableName": "jump key",
      "spriteName": "$glitch_target",
      "value": "space",
      "input": {
        "type": "key"
      }
    }
  ],
  "info": [
    {
      "text": "Give a piece the ability to jump. Works best together with the GRAVITY <i class='icon icon-appledown green'></i> sticker",
      "image": "provision/glitches/jump/jump.gif"
    }
  ],
  "codeImage": "provision/glitches/jump/jump.png",
  "code": null,
  "zip": null,
  "sb3": null
};